module.exports = __webpack_public_path__ + "img/Group 1105one3.6bbcd7bc.png";